import { render, staticRenderFns } from "./clazz-article-editor.vue?vue&type=template&id=a72ec856&scoped=true&"
import script from "./clazz-article-editor.vue?vue&type=script&lang=js&"
export * from "./clazz-article-editor.vue?vue&type=script&lang=js&"
import style0 from "./clazz-article-editor.vue?vue&type=style&index=0&id=a72ec856&prod&scoped=true&lang=css&"
import style1 from "./clazz-article-editor.vue?vue&type=style&index=1&id=a72ec856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ec856",
  null
  
)

export default component.exports